import { AddInError } from './addInError';

export class AccessTokenValidatorError extends AddInError {
  constructor(context?: Record<string, unknown>) {
    super('Access token validation failed', context);
    this.name = 'AccessTokenValidatorError';
    Object.setPrototypeOf(this, AccessTokenValidatorError.prototype);
  }
}
